import $http from '@Config/axios';

const prefix = 'items-guarda-chuva';

export const UmbrellaItemPresenter = {
	findAll: () => $http.get(`${prefix}`)
};
